var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "entry-multi-tab" }, [
    _c(
      "main",
      { staticClass: "entry-multi-tab__wrapper" },
      [
        _c(
          "a-tabs",
          {
            attrs: {
              hideAdd: "",
              type: "editable-card",
              activeKey: _vm.activeKey
            },
            on: { change: _vm.onChange, edit: _vm.onEdit }
          },
          [
            _vm._l(_vm.panes, function(pane, index) {
              return _c(
                "a-tab-pane",
                { key: pane.key, attrs: { closable: pane.closable } },
                [
                  index === 0
                    ? _c("a-icon", {
                        attrs: { slot: "tab", type: "home" },
                        slot: "tab"
                      })
                    : _c("span", { attrs: { slot: "tab" }, slot: "tab" }, [
                        _vm._v(_vm._s(_vm._f("menuNameRender")(pane)))
                      ])
                ],
                1
              )
            }),
            _c(
              "div",
              {
                attrs: { slot: "tabBarExtraContent" },
                slot: "tabBarExtraContent"
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "demo",
                        rawName: "v-demo",
                        value: "guideTo",
                        expression: "'guideTo'"
                      }
                    ],
                    staticClass: "entry-oguide"
                  },
                  [
                    _c("icon-font", {
                      staticStyle: { "margin-right": "5px" },
                      attrs: { type: "gb-icon-helper-circle" }
                    }),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("layouts.operation.guide")))
                    ])
                  ],
                  1
                ),
                _c(
                  "a-dropdown",
                  { attrs: { trigger: ["click"] } },
                  [
                    _c(
                      "div",
                      { staticClass: "dropdown-content" },
                      [_c("a-icon", { attrs: { type: "down" } })],
                      1
                    ),
                    _c(
                      "a-menu",
                      {
                        attrs: { slot: "overlay" },
                        on: { click: _vm.closeMenuClick },
                        slot: "overlay"
                      },
                      [
                        _c("a-menu-item", { key: "ClosePane" }, [
                          _vm._v(_vm._s(_vm.$t("tabs.close.current")))
                        ]),
                        _c("a-menu-item", { key: "CloseRightPanes" }, [
                          _vm._v(_vm._s(_vm.$t("tabs.close.right")))
                        ]),
                        _c("a-menu-item", { key: "CloseLeftPanes" }, [
                          _vm._v(_vm._s(_vm.$t("tabs.close.left")))
                        ]),
                        _c("a-menu-item", { key: "CloseAllPane" }, [
                          _vm._v(_vm._s(_vm.$t("tabs.close.all")))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }